export default function PageNoteFound() {
  return (
    <div>
      <h1>PageNoteFound</h1>
    </div>
  );
}
